export default {
  productionYears(state) {
    return state.years;
  },
  cplds(state) {
    return state.cplds;
  },
  cpldVolumes(state) {
    return state.cpldVolumes;
  },
  hdlPreferences(state) {
    return state.hdls;
  },
  prochipDBResponse(state) {
    return state.prochipData;
  },
  ProchipAPIError(state) {
    return state.isProchipAPIError;
  },
  accessToken(state) {
    return state.accessToken;
  },
  userProfileDetails(state) {
    return state.userProfileDetails;
  }
};